import React from "react"
import Contact from "../components/contact/Contact"
import Hero from "../components/hero/Hero"
import Residencies from "../components/residencies/Residencies"
import Value from "../components/value/Value"

const Website = () => {
  return (
    <div >
      <Hero />

      
      <Residencies />
      <Value />
      <Contact />

    </div>
  )
}

export default Website
